/**
 * Links fra widget-kortene direkte til den rigtige booking-side på studiets site.
 * Rene funktioner (ingen Preact), så HS' jest kan teste dem.
 *
 * Før gik «Book» på behandlinger og «Tilmeld dig» på forløb til den generelle
 * liste, så kunden skulle finde det samme kort igen (kundefejl 17-10-2026).
 */

/**
 * Behandling: `/behandlinger?behandling=<id>` åbner booking-vinduet for netop den
 * behandling (deep-link-kontrakt i TreatmentsPageClient). Gælder også behandlinger
 * uden kategori; id'et er altid behandlingens eget.
 */
export function treatmentBookingHref(siteUrl: string, treatmentId: string): string {
  return `${siteUrl}/behandlinger?behandling=${encodeURIComponent(treatmentId)}`
}

/**
 * Forløb: `/saeson/<slug>` viser forløbet og springer direkte til tilmeldingen, når
 * det kun har ét aktivt hold. Uden slug: forløbslisten.
 */
export function seasonSignupHref(siteUrl: string, slug: string | null | undefined): string {
  return slug ? `${siteUrl}/saeson/${encodeURIComponent(slug)}` : `${siteUrl}/saeson`
}
